import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {
    ImgBridgeSearch,
    ImgUnderpassSearch,
    ImgConstructionManagement,
    ImgDataExchange,
    ImgBridgeInspect,
    ImgWaterHeightSearch
} from '../../../style/images/system-icons'

const CardWorkInformation = ({func}) => {
    const display = () => {
        let temp = []
        if (func.length>0){
            func.sort((a,b)=>{
                if (a.name.includes("橋查詢")&&!b.name.includes("橋查詢"))return -1;
                if (!a.name.includes("橋查詢")&&b.name.includes("橋查詢"))return 1;
                return 0
            })
            func.forEach(item=>{
                if (item.name.includes("車行橋查詢")){
                    temp.push(
                    <Col className='col-3 p-3' key={item.key}>
                    <div className="text-center">
                        <img src={ImgBridgeSearch} width="50" alt="" />
                        <div><a target="_self" href="./Workinformation/BridgeSearch">車行橋查詢</a></div>
                    </div>
                    </Col>
                )
                }else if (item.name.includes("人行橋查詢")){
                    temp.push(
                        <Col className='col-3 p-3' key={item.key}>
                        <div className="text-center">
                            <img src={ImgBridgeSearch} width="50" alt="" />
                            <div><a target="_self" href="./Workinformation/FootBridgeSearch">人行橋查詢</a></div>
                        </div>
                        </Col>
                    )
                }
                else if (item.name.includes("地下道查詢")){
                    temp.push(
                        <Col className='col-3 p-3' key={item.key}>
                        <div className="text-center">
                            <img src={ImgUnderpassSearch} width="50" alt="" />
                            <div><a target="_self" href="./Workinformation/UnderpassSearch">地下道查詢</a></div>
                        </div>
                    </Col>
                    )
                }else if (item.name.includes("維修及施工管理")){
                    temp.push(
                        <Col className='col-3 p-3' key={item.key}>
                        <div className="text-center">
                            <img src={ImgConstructionManagement} width="50" alt="" />
                            <div><a target="_self" href="./Workinformation/RepairAndConstruction">維修及施工管理</a></div>
                        </div>
                    </Col>
                    )
                }
            })
        }
        return temp;
    }
    const displaySec = () => {
        let temp = []
        if (func.length>0){
            func.forEach(item=>{
                if (item.name.includes("資料交換")){
                    temp.push(
                        <Col className='col-3 p-3' key={item.key}>
                        <div className="text-center">
                            <img src={ImgDataExchange} width="50" alt="" />
                            <div><a target="_self" href="./Workinformation/DataTransfer">資料交換</a></div>
                        </div>
                    </Col>
                )
                }else if (item.name.includes("橋樑檢測及抽測")){
                    temp.push(
                        <Col className='col-3 p-3' key={item.key}>
                        <div className="text-center">
                            <img src={ImgBridgeInspect} width="50" alt="" />
                            <div><a target="_self" href="./Workinformation/BridgeTest">橋梁檢測及抽測</a></div>
                        </div>
                    </Col>
                    )
                }else if (item.name.includes("水位查詢模組")){
                    temp.push(
                        <Col className='col-3 p-3' key={item.key}>
                        <div className="text-center">
                            <img src={ImgWaterHeightSearch} width="50" alt="" />
                            <div><a target="_self" href="./Workinformation/WaterLevel">水位查詢模組</a></div>
                        </div>
                    </Col>
                    )
                }
            })
        }
        return temp;
    }
    return (
        <Container>
            <Row>
                <h4 className="l-system-switch-panel__title text-left mb-3">業務資訊功能</h4>
            </Row>
            <Row>
                    {display()}
            </Row>
            <Row>
                {displaySec()}
            </Row>
        </Container>
    )
}
export default CardWorkInformation;